import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const eocAlertIssueSyncingRoute: InvariantJiraRoute = {
	name: 'eoc-alert-issue-syncing',
	path: '/jira/settings/products/ops/syncs',
	exact: true,
};
